import React from 'react'
import './HomeData.scss';
import PhotoCard from "../edCard/edCard"

import img1 from "../../Assets/past_editions/481077039_1151200236519087_5081532108870179981_n.jpg";
import img2 from "../../Assets/past_editions/482069004_1151200259852418_79356086366381026_n.jpg";
import img3 from "../../Assets/past_editions/482053366_1151200066519104_658439242551520061_n.jpg";
import img4 from "../../Assets/past_editions/482083519_1151200026519108_2775271662465460893_n.jpg";
import img5 from "../../Assets/past_editions/482200983_1151199446519166_1724202758256782127_n.jpg";
import img6 from "../../Assets/past_editions/482206145_1151201286518982_4235337224411554159_n.jpg";

import img_2019_1 from "../../Assets/past_editions/e2023_1.jpg";
import img_2019_2 from "../../Assets/past_editions/e2023_2.jpg";
import img_2019_3 from "../../Assets/past_editions/e_2023_3.jpg";
import img_2019_4 from "../../Assets/past_editions/e_2023_4.jpg";
import img_2019_5 from "../../Assets/past_editions/e_2023_5.jpg";
import img_2019_6 from "../../Assets/past_editions/e_2023_6.jpg";

import Sponsor from '../Sponsor/Sponsor';
import aa_bio from '../../Assets/program/sponsor_aa_biotechnology_2.png'
import lab_jot from "../../Assets/program/LabJOT.jpg"
import biocelt from "../../Assets/program/bioceltix.jpg"
import linegal from "../../Assets/program/linegal.png"
import genomed from "../../Assets/program/genomed.jpg"
import revvity from "../../Assets/program/revity.jpg"

export default function HomeData() {
  return (
    <div className='HomeData'>
        <div className='HomeData-Register'>
            <h1>Join us, let's spend this few days together!</h1>
            <div className='HomeData-Register-Fast'>
                <PhotoCard img={[img1,img2, img3, img4, img5, img6]} big_title={"Genomica 2024"} title={"Our edition from callendar year 2024"} />
                <PhotoCard img={[img_2019_1,img_2019_2,img_2019_3,img_2019_4,img_2019_5,img_2019_6]} big_title={"Genomica 2019"} title={"Far Far away in 2019 ;)"} />
            </div>
            <h1>Our partners for 2026th edition:</h1>
            <div className='Sponsors-List'>
              <Sponsor title={'Genomed'} image={genomed} link="https://www.genomed.pl/" />
              <Sponsor title={'Revvity'} image={revvity} link="https://www.revvity.com/" />
              <Sponsor title={'A&A Biotechnology'} image={aa_bio} link="https://aabiot.com" />
              <Sponsor title={'Lab-JOT'} image={lab_jot} link="https://www.labjot.com/" />
              <Sponsor title={'Bioceltix'} image={biocelt} link="https://bioceltix.com/" />
              <Sponsor title={'Linegal Chemicals'} image={linegal} link="https://linegal.pl/" />
              {/* <Sponsor title={'Eppendorf'} image={ependorf} link="https://www.eppendorf.com" /> */}
              {/* <Sponsor title='KNSB InSilico' image={inSilico} link="https://insilico.knsb.pl" /> */}
            </div>
        </div>
    </div>
  )
}
